import React, { ReactNode, useState } from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { Button } from "reactstrap";

import { Table, TableProps } from "@ui/Table";
import { messages as uiMessages } from "@ui/messages";

export interface CollapsableProps<T> extends TableProps<T> {
    data: T[];
    limit: number;
    children?: ReactNode;
}

type TypedComponent = <T>(props: CollapsableProps<T>) => React.ReactElement<CollapsableProps<T>>;
export const Collapsable: TypedComponent = (props) => {
    const { data, limit, children } = props;

    // Use hooks to manage the state
    const [expanded, setExpanded] = useState(false);

    // Determine whether it's expandable
    const expandable = data.length > limit;
    // How many items to show
    const toShow = !expandable || expanded ? data.length : limit;
    // And set the class and button based on the above.
    let className = "table-collapsable";
    const buttonProps = {
        tag: "a" as React.ReactType,
        href: "#",
        color: "primary",
        outline: true,
        onClick: (e: React.MouseEvent) => { e.preventDefault(); setExpanded(!expanded); },
        className: "table-collapsable__show-more",
    };
    let buttonMesssage = uiMessages.buttonShowMore;
    if (expanded) {
        className += " table-collapsable--expanded";
        buttonProps.color = "secondary";
        buttonMesssage = uiMessages.buttonShowFewer;
    }
    else {
        className += " table-collapsable--collapsed";
    }

    return (
        <div className={className}>
            <Table {...props} pageSize={toShow}>
                {children}
            </Table>
            {expandable &&
                <div className="table-collapsable__show-more-container">
                    <Button {...buttonProps}>
                        <FormattedMessage {...buttonMesssage} />
                    </Button>
                </div>}
        </div>
    );
};
